import * as React from 'react';
import { TextField } from '@symphony-ui/uitoolkit-components';
import PopupButtons from './PopupButtons';
const IsinsPopup = ({ data, hasOverride, save }) => {
    const [isin144A, setIsin144A] = React.useState(data?.override?.identifiers !== undefined ?
        data.override.identifiers.find(i => i.regulation === 'RULE_144A' && i.type === 'ISIN')?.value :
        data?.data?.identifiers?.find(i => i.regulation === 'RULE_144A' && i.type === 'ISIN')?.value);
    const [isin, setIsin] = React.useState(data?.override?.identifiers !== undefined ?
        data.override.identifiers.find(i => i.regulation === undefined && i.type === 'ISIN')?.value :
        data?.data?.identifiers?.find(i => i.regulation === undefined && i.type === 'ISIN')?.value);
    const [isinRegS, setIsinRegS] = React.useState(data?.override?.identifiers !== undefined ?
        data.override.identifiers.find(i => i.regulation === 'REGS' && i.type === 'ISIN')?.value :
        data?.data?.identifiers?.find(i => i.regulation === 'REGS' && i.type === 'ISIN')?.value);
    const value = React.useMemo(() => {
        return [{ type: 'ISIN', regulation: 'RULE_144A', value: isin144A ?? '' },
            { type: 'ISIN', regulation: 'REGS', value: isinRegS ?? '' },
            { type: 'ISIN', regulation: undefined, value: isin ?? '' }
        ];
    }, [isin, isin144A, isinRegS]);
    const onChangeIsin = React.useCallback((event) => {
        setIsin(event.target.value);
        setIsin144A('');
        setIsinRegS('');
    }, []);
    const onChangeIsin144A = React.useCallback((event) => {
        setIsin144A(event.target.value);
        setIsin('');
    }, []);
    const onChangeIsinRegS = React.useCallback((event) => {
        setIsinRegS(event.target.value);
        setIsin('');
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(TextField, { label: "ISIN", onChange: onChangeIsin, value: isin }),
        React.createElement(TextField, { label: "ISIN (144A)", onChange: onChangeIsin144A, value: isin144A }),
        React.createElement(TextField, { label: "ISIN (RegS)", onChange: onChangeIsinRegS, value: isinRegS }),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { value: value, hasOverride: hasOverride, save: save, isDisabled: false }))));
};
export default IsinsPopup;
